import { css } from '@emotion/react';

import color from 'components/common/color';

const MUTED = '#5a6478';
const BORDER = '#dfe3ea';

export const pageStyles = css`
  display: flex;
  min-height: 100vh;
  font-family: "Roboto", sans-serif;
  background-color: #f6f7f9;

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

export const brandPanelStyles = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 0 0 45%;
  padding: 48px 56px;
  box-sizing: border-box;
  color: ${color.WHITE};
  background-color: ${color.BLUE};

  @media screen and (max-width: 768px) {
    flex: none;
    gap: 24px;
    padding: 28px 24px;
  }
`;

export const logoStyles = css`
  border-radius: 10px;
  background-color: ${color.WHITE};
  object-fit: cover;
`;

export const accentStyles = css`
  display: block;
  width: 40px;
  height: 4px;
  margin-bottom: 20px;
  border-radius: 2px;
  background-color: ${color.ORANGE};
`;

export const brandTitleStyles = css`
  margin: 0 0 12px;
  font-size: 34px;
  font-weight: 700;
  line-height: 1.2;

  @media screen and (max-width: 768px) {
    font-size: 24px;
  }
`;

export const brandCopyStyles = css`
  max-width: 380px;
  margin: 0;
  font-size: 16px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.75);
`;

export const brandFooterStyles = css`
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const formPanelStyles = css`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
`;

export const cardStyles = css`
  width: 100%;
  max-width: 380px;
  padding: 40px 36px;
  box-sizing: border-box;
  border: 1px solid ${BORDER};
  border-radius: 12px;
  background-color: ${color.WHITE};
  box-shadow: 0 8px 24px rgba(29, 61, 112, 0.06);

  @media screen and (max-width: 480px) {
    padding: 32px 24px;
  }
`;

export const titleStyles = css`
  margin: 0 0 6px;
  font-size: 24px;
  font-weight: 700;
  color: ${color.BLUE};
`;

export const hintStyles = css`
  margin: 0 0 28px;
  font-size: 14px;
  color: ${MUTED};
`;

export const googleButtonStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  height: 44px;
  border: 1px solid ${BORDER};
  border-radius: 8px;
  background-color: ${color.WHITE};
  font-family: inherit;
  font-size: 15px;
  font-weight: 500;
  color: #1f1f1f;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease;

  &:hover:not(:disabled) {
    background-color: #f6f7f9;
    border-color: #c7cdd8;
  }

  &:focus-visible {
    outline: 2px solid ${color.LIGHT_BLUE};
    outline-offset: 2px;
  }

  &:disabled {
    cursor: progress;
    opacity: 0.7;
  }
`;

export const errorStyles = css`
  margin-top: 16px;
  padding: 10px 12px;
  border: 1px solid #f5c2c0;
  border-radius: 8px;
  background-color: #fdf0ef;
  font-size: 13px;
  line-height: 1.5;
  color: #b42318;
`;
